module.exports = {"451422100":"城中镇","451422101":"爱店镇","451422102":"明江镇","451422103":"海渊镇","451422104":"桐棉镇","451422105":"那堪镇","451422106":"亭亮镇","451422202":"寨安乡","451422203":"峙浪乡","451422204":"东安乡","451422205":"板棍乡","451422206":"北江乡","451422209":"那楠乡","451422401":"国营宁明华侨农场","451422402":"国营天西华侨农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451422.json
// module id = 2002
// module chunks = 0